import React from 'react';
import { CampaignMappingView } from 'src/features/CampaignMapping';
import { CampaignMappingsDataContextProvider } from 'src/features/CampaignMapping';

export const CampaignMapping: React.FC = () => {
  return (
    <CampaignMappingsDataContextProvider>
      <CampaignMappingView />
    </CampaignMappingsDataContextProvider>
  );
};
